import { render, staticRenderFns } from "./about.vue?vue&type=template&id=c956e5e2&"
import script from "./about.vue?vue&type=script&lang=js&"
export * from "./about.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Baner: require('/var/www/components/baner/baner.vue').default,SliderDealer: require('/var/www/components/slider-dealer/slider-dealer.vue').default,CatalogListIndex: require('/var/www/components/catalog/catalog-list/catalog-list-index.vue').default,SeoTextAbout: require('/var/www/components/seo-text/seo-text-about.vue').default})
